<div class="logo">
  <p class="version">v1.0.2508.00</p>
  <a href="{{url}}">
    <img *ngIf="'system.langCode' | translate" width="171" height="28" src="/assets/images/logo_{{'system.langCode' | translate}}.png"
         srcset="/assets/images/logo_{{'system.langCode' | translate}}.png 1x, /assets/images/logo_{{'system.langCode' | translate}}_2x.png 2x">
  </a>
</div>
